/**
 * Better-Auth Client (Browser-seitig).
 * Wird in Client-Components fuer signIn/signUp/signOut benutzt.
 */
"use client";

import { createAuthClient } from "better-auth/react";
import { twoFactorClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : undefined,
  plugins: [twoFactorClient()],
});

export const { useSession, signIn, signOut, signUp, twoFactor } = authClient;
